export const getFormattedWidth = (pixels: boolean, width?: number): string => {
  if (pixels) {
    return `${width}px`;
  }
  return `${width}%`;
};
